import React, { useState } from 'react';
import PropTypes from 'prop-types';

import VisualMediaEmbeds from 'components/property/visual_media_embeds';
import VisualMediaEmbedsCustomer from 'components/property/visual_media_embeds_customer';
import PhotoBulkActions from 'components/photos/bulk_actions';
import { deleteVisualMedia, visualMediaId } from 'components/property/visual_media_shared';

export default function VisualMediaForm({
  customerEmbeds,
  embeds,
  ovalroomGroupAdmin,
  parentName,
  visualMediaTypeOptions,
  onCustomerEmbedsChange,
  onEmbedsChange
}) {
  const [selectedVisualMediaIds, setSelectedVisualMediaIds] = useState([]);

  const embedsToUse = ovalroomGroupAdmin ? embeds : customerEmbeds;
  const embedIds = embedsToUse.map(visualMediaId);
  const noEmbeds = embedsToUse.length === 0;
  const allSelected = noEmbeds ? false : embedIds.every(embedId => selectedVisualMediaIds.includes(embedId));
  const selectedEmbeds = embedsToUse.filter(embed => selectedVisualMediaIds.includes(visualMediaId(embed)));

  function handleBulkCheckboxClick(id) {
    if (selectedVisualMediaIds.includes(id)) {
      setSelectedVisualMediaIds(selectedVisualMediaIds.filter(selectedId => selectedId !== id));
    } else {
      setSelectedVisualMediaIds([...selectedVisualMediaIds, id]);
    }
  }

  function handleSelectALl() {
    if (allSelected) {
      setSelectedVisualMediaIds([]);
    } else {
      setSelectedVisualMediaIds(embedIds);
    }
  }

  function handleBulkDelete() {
    const updater = ovalroomGroupAdmin ? onEmbedsChange : onCustomerEmbedsChange;
    const updatedEmbeds = deleteVisualMedia(embedsToUse, selectedVisualMediaIds);

    updater(updatedEmbeds);
    setSelectedVisualMediaIds([]);
  }

  function handleBulkPreview() {
    selectedEmbeds.forEach((embed) => {
      if (embed.embedUrl) window.open(embed.embedUrl, '_blank');
    });
    setSelectedVisualMediaIds([]);
  }

  return (
    <div className="visual-media-container mt-5">
      <PhotoBulkActions
        allSelected={allSelected}
        disabled={selectedVisualMediaIds.length === 0}
        label="Visual Media"
        showLimit={false}
        onBulkDelete={handleBulkDelete}
        onBulkPreview={handleBulkPreview}
        onSelectAll={handleSelectALl}
      />
      {ovalroomGroupAdmin ? (
        <VisualMediaEmbeds
          mediaTypeOptions={visualMediaTypeOptions}
          parentName={parentName}
          selectedVisualMediaIds={selectedVisualMediaIds}
          visualMediaEmbeds={embeds}
          onBulkCheckboxClick={handleBulkCheckboxClick}
          onChange={onEmbedsChange}
        />
      ) : (
        <VisualMediaEmbedsCustomer
          parentName={parentName}
          selectedVisualMediaIds={selectedVisualMediaIds}
          visualMediaEmbeds={customerEmbeds}
          onBulkCheckboxClick={handleBulkCheckboxClick}
          onChange={onCustomerEmbedsChange}
        />
      )}
    </div>
  );
}

VisualMediaForm.propTypes = {
  customerEmbeds: PropTypes.array.isRequired,
  embeds: PropTypes.array.isRequired,
  ovalroomGroupAdmin: PropTypes.bool.isRequired,
  parentName: PropTypes.string.isRequired,
  visualMediaTypeOptions: PropTypes.array.isRequired,
  onCustomerEmbedsChange: PropTypes.func.isRequired,
  onEmbedsChange: PropTypes.func.isRequired
};
